import { Component, OnInit, OnDestroy, WritableSignal, signal } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../services/settings.service';
import { FileUploadService } from 'src/app/services/file-upload.service';
import { SharedServicesService } from 'src/app/services/shared-services.service';
import { MessageService } from 'primeng/api';
import { GlobalServicesService } from 'src/app/services/global-services.service';
import { nanoid } from 'nanoid'

type OrganizationTabs = "organization-settings" | "branch-settings";

@Component({
    selector: 'app-company-details',
    templateUrl: './company-details.component.html',
    styleUrls: ['./company-details.component.css'],
    providers: [SharedServicesService, MessageService],
    standalone: false
})

export class CompanyDetailsComponent implements OnInit, OnDestroy {

  addTemplateSidebar: boolean = false;
  userInfo: any = [];
  companyData: any = [];
  showPlaceholder: boolean = false;
  _templateTitle: string = '';
  saveBtnLoading: boolean = false;
  saveDisable: boolean = false;
  profilePic: File[] = [];
  profileBase64: any = '';
  s3Domain: string = 'https://s3.amazonaws.com';
  logoSrc: any = '';
  logoSrcEdit: any = '';
  coverImageSrcEdit: string = '';
  faviconSrcEdit: string = '';
  companyDetails: FormGroup = new FormGroup({
    name: new FormControl('', Validators.required),
    industry: new FormControl('', Validators.required),
    company_category: new FormControl('', Validators.required),
    pan: new FormControl('', Validators.pattern(/^[A-Z]{5}[0-9]{4}[A-Z]$/)),
    gst: new FormControl('',Validators.pattern(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/)),
    tin: new FormControl('',Validators.pattern(/^[0-9]{11}$/)),
    logo: new FormControl(""),
    cover_image: new FormControl(""),
    fav_icon: new FormControl(""),
    date_format: new FormControl(""),
    time_format: new FormControl(""),
    sampleValues: new FormGroup({
      pan: new FormControl('ABCDE1234F'),
      gst: new FormControl('22AAAAA0000A1Z5'),
      tin: new FormControl('12345678901')
    })
  });

  companyName: string = '';
  industry: string = '';
  panNumber: string = '';
  gstNumber: string = '';
  tinNumber: string = '';
  companyCategory: string = '';
  panNumberShow: boolean = false;
  gstNumberShow: boolean = false;
  tinNumberShow: boolean = false;
  clicked: boolean = false;
  companyId: string = '';
  userPrivileges: Set<string> = new Set();

  industryList: any = [
    { label: "Research" },
    { label: "Development" },
    { label: "Core" }
  ];
  primaryLanguageList: any = [
    { label: "English" },
  ]

  timeList: any[] = [
    { name: '12 hours', value: '12' },
    { name: '24 hours', value: '24' },
  ];
  dateList: any = [
    { name: 'DD/MM/YYYY', value: 'DD/MM/YYYY' },
    { name: 'DD-MM-YYYY', value: 'DD-MM-YYYY' },
    { name: 'DD/MMM/YY', value: 'DD/MMM/YY' },
    { name: 'DD-MMM-YY', value: 'DD-MMM-YY' },
    { name: 'DD/MMM/YYYY', value: 'DD/MMM/YYYY' },
    { name: 'DD-MMM-YYYY', value: 'DD-MMM-YYYY' },
    { name: 'YYYY/MM/DD', value: 'YYYY/MM/DD' },
    { name: 'YYYY-MM-DD', value: 'YYYY-MM-DD' }
  ];
  companyCategoryList: any = ["Private Limited", "Public Limited"]
  loadingCompanyDetails: boolean = false;

  constructor(private settings: SettingsService, private fileUploadService: FileUploadService, private sharedService: SharedServicesService, private messageService: MessageService, private globalService: GlobalServicesService) { }

  ngOnInit(): void {
    this.companyId = localStorage.getItem('companyUUID') ?? '';
    this.globalService.privilegeDetailsSubject.subscribe((privileges) => {
      this.userPrivileges = privileges;
    });    
    this.getCompanyDetails();
  }

  getCompanyDetails() {
    this.loadingCompanyDetails = true;
    this.settings.getCompanyDataFastApi().subscribe({
      next: (res: any) => {
        if (res.status === 200) {
          this.companyData = res.body ? res.body : [];
          this.sharedService.emitChange(res.body?.logo);
          this.logoSrc = this.companyData.logo ;
          this.logoSrcEdit = this.companyData.logo ;
          this.coverImageSrcEdit = this.companyData.cover_image ;
          this.faviconSrcEdit = this.companyData.fav_icon;


          this.userInfo = [
            { field: "Company", value: res.body.name ?? '-' },
            { field: "Industry", value: res.body.industry ?? '-' },
            { field: "Company Category", value: res.body.company_category ?? '-' },
            { field: "No. of Branches", value: res.body.branches_count ?? '-' },
            { field: "PAN Number", value: res.body.pan ?? '-' },
            { field: "GST Number", value: res.body.gst ?? '-' },
            { field: "TIN Number", value: res.body.tin ?? '-' },
          ];

          this.openCompanyDetails();
        }
        this.loadingCompanyDetails = false;
      },
      error: (err) => {
        console.error('Error fetching company data:', err);
        this.loadingCompanyDetails = false;
      }
    });
  }

  openCompanyDetails() {
    this.addTemplateSidebar = true;
    this.companyName = this.companyData.name;
    this.industry = this.companyData.industry;
    this.companyCategory = this.companyData.company_category;
    this.panNumber = this.companyData.pan;
    this.gstNumber = this.companyData.gst;
    this.tinNumber = this.companyData.tin;
    this.companyDetails.get('time_format')?.setValue(this.companyData.time_format)
  }

  private cleanupObjectUrls() {
    if (this.logoSrcEdit && this.logoSrcEdit.startsWith('blob:')) {
      URL.revokeObjectURL(this.logoSrcEdit);
    }
    if (this.coverImageSrcEdit && this.coverImageSrcEdit.startsWith('blob:')) {
      URL.revokeObjectURL(this.coverImageSrcEdit);
    }
    if (this.faviconSrcEdit && this.faviconSrcEdit.startsWith('blob:')) {
      URL.revokeObjectURL(this.faviconSrcEdit);
    }
  }

  ngOnDestroy(): void {
    this.cleanupObjectUrls();
  }
  cancel = () => {
    this.companyDetails.reset();
    this.addTemplateSidebar = false;
    this.cleanupObjectUrls(); // Clean up before resetting
    this.logoSrcEdit = this.companyData.logo;
    this.coverImageSrcEdit = this.companyData.cover_image;
    this.faviconSrcEdit = this.companyData.fav_icon;
  }

  saveCompanyDetails = () => {
    if(!this.companyDetails.dirty) {
      this.messageService.add({ 
        severity: 'warn', 
        summary: 'No Changes Detected', 
        detail: 'You haven\'t made any changes to the form. Please update at least one field before submitting.' 
      });
      return;
    }

    this.saveBtnLoading = true;
    this.clicked = true;
    this.companyDetails.get('name')?.markAsTouched();
    this.companyDetails.get('name')?.markAsDirty();
    if (this.sharedService.hasSecurityViolations(this.companyDetails, ['name'])) {
      this.messageService.add({ 
        severity: 'error', 
        summary: 'Invalid Input', 
        detail: 'Invalid input format in some fields.' 
      });
      this.saveBtnLoading = false;
      return;
    }

    if (this.companyDetails.valid) {
      let secureFormValue = this.sharedService.getSecurePayload(this.companyDetails.value);
      const payload = this.cleanPayload(secureFormValue);
  
      this.settings.updateCompanyDataFastApi(payload).subscribe({
        next: (res: any) => {
          if (res.status === 200) {
            this.messageService.add({
              severity: 'success',
              summary: 'Success',
              detail: res.body.detail,
            });
            this.addTemplateSidebar = false;
            this.companyDetails.reset();
            this.getCompanyDetails();            
            this.clicked = false;
            this.cleanupObjectUrls();
            this.logoSrcEdit = '';
            this.coverImageSrcEdit = '';
            this.faviconSrcEdit = '';
          }
          this.saveBtnLoading = false;
        },
        error: (err) => {
          console.error('Error updating company data:', err);
          this.saveBtnLoading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Error',
            detail: err.error?.detail || 'Failed to update company details',
          });
        }
      });
    } else {
      this.messageService.add({ 
        severity: 'error', 
        summary: 'Failed', 
        detail: 'Please Fill the Required Fields'
      });
      this.saveBtnLoading = false;
    }
  }

  private cleanPayload(formValue: any): any {
    const payload = { ...formValue };

    // Define field categories dynamically
    const fileFields = ['logo', 'cover_image', 'fav_icon'];
    const nullableFields = ['pan', 'gst', 'tin', 'industry', 'company_category'];

    // Handle file fields - remove if empty
    fileFields.forEach(field => {
      if (!payload[field] || payload[field] === '') {
        delete payload[field];
      }
    });

    nullableFields.forEach(field => {
      if (!payload[field] || payload[field] === '' || (typeof payload[field] === 'string' && payload[field].trim() === '')) {
        payload[field] = null;
      }
    });

    delete payload.sampleValues;
    return payload;
  }

  onSelectLogo(event: any, action?: any) {
    this.profilePic.push(...event.addedFiles);
    this.handleUpload(event, action)
  }
  handleUpload(event: any, type: 'logo' | 'cover' | 'fav_icon') {
    const file = event?.target?.files?.[0];
    if (!file) {
      console.error('No file selected');
      return;
    }

    if (file.type === 'image/svg+xml') {
      if (type === 'logo') {
        this.logoSrcEdit = URL.createObjectURL(file);
        this.getSignedUrlAndUpload(file, 'logo');
      } else if(type === 'cover') {
        this.coverImageSrcEdit = URL.createObjectURL(file);
        this.getSignedUrlAndUpload(file, 'cover');
      }
      else if(type === 'fav_icon') {
        this.faviconSrcEdit = URL.createObjectURL(file);
        this.getSignedUrlAndUpload(file, 'fav_icon');
      }
      return;
    }
    const reader = new FileReader();
    reader.onload = (e: any) => {
      let img: any = new Image();
      img.src = e.target.result;
      const valid = (state: boolean) => {
        if (state) {
          if (type === 'logo') {
            this.logoSrcEdit = reader.result as string;
            this.getSignedUrlAndUpload(file, 'logo');
          } else if(type === 'cover') {
            this.coverImageSrcEdit = reader.result as string;
            this.getSignedUrlAndUpload(file, 'cover');
          }
          else if(type === 'fav_icon') {
            this.faviconSrcEdit = reader.result as string;
            this.getSignedUrlAndUpload(file, 'fav_icon');
          }
        }
        else {
          this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Invalid image size' });
        }
      };

      img.onload = function () {
        const width = this.width;
        const height = this.height;
        const isValid = type === 'logo' 
        ? (width <= 800 && height <= 400)
        : type === 'cover'
        ? (width <= 1920 && height <= 1080)
        : (width <= 96 && height <= 96);
        valid(isValid);
      };
    };
    reader.readAsDataURL(file);
  }


  onRemoveProfilePic(event: any) {
    this.profilePic.splice(this.profilePic.indexOf(event), 1);
  }

  deleteFile(type: 'logo' | 'cover' | 'fav_icon') {
    if (type === 'logo') {
      this.companyDetails.get('logo')?.setValue("");
      this.companyDetails.get('logo')?.markAsDirty();
      this.logoSrcEdit = "";
    } else if (type === 'cover') {
      this.companyDetails.get('cover_image')?.setValue("");
      this.companyDetails.get('cover_image')?.markAsDirty();
      this.coverImageSrcEdit = "";
    }
    else if (type === 'fav_icon') {
      this.companyDetails.get('fav_icon')?.setValue("");
      this.companyDetails.get('fav_icon')?.markAsDirty();
      this.faviconSrcEdit = "";
    }
  }

  showPassword(selector: any) {
    let x: any = document.getElementsByClassName(selector)[0];
    if (!x) { return; }
    if (x.type === "password") {
      x.type = "text";
    } else {
      x.type = "password";
    }
  }

  getSignedUrlAndUpload(file: any, type: 'logo' | 'cover' | 'fav_icon') {
    let fileName = file.name.split(".");
    let fileExtension = fileName.pop();
    const timestamp = new Date().getTime();
    fileName = `${fileName.join().replace(/\s/g, "").replace(/[^\w\s]/gi, '')}_${timestamp}.${fileExtension}`;
    const renamedFile = new File([file], fileName, { type: file.type });
    const filePath = `temp/${this.companyId}/${fileName}`;

    const payload = {
      file_path: filePath,
      bucket_type: 'public',
      origin:"company_details"
    };

    this.fileUploadService.getSignedUrlGCS(payload).subscribe({
      next: (response: any) => {
        if (response && response.body.signed_url) {
          this.uploadFileToGCS(response.body.signed_url, renamedFile, filePath, fileName, type);
        }
      },
      error: (error) => {
        console.error('Error getting signed URL:', error);
      }
    });
  }

  uploadFileToGCS(signedUrl: string, file: any, filePath: string, fileName: string, type: 'logo' | 'cover'| 'fav_icon') {
    this.fileUploadService.uploadUsingSignedUrlGCS(signedUrl, file).subscribe({
      next: (response: any) => {
        if (response && response.status === "success") {
          const baseUrl = signedUrl.split(fileName)[0];
          const gcsUrl = `${baseUrl}${fileName}`;
          
          if (type === 'logo') {
            this.logoSrcEdit = gcsUrl;
            this.companyDetails.get('logo')?.setValue(fileName);
            this.companyDetails.get('logo')?.markAsDirty();
          } else if (type === 'cover') {
            this.coverImageSrcEdit = gcsUrl;
            this.companyDetails.get('cover_image')?.setValue(fileName);
            this.companyDetails.get('cover_image')?.markAsDirty();
          }
          else if (type === 'fav_icon') {
            this.faviconSrcEdit = gcsUrl;
            this.companyDetails.get('fav_icon')?.setValue(fileName);
            this.companyDetails.get('fav_icon')?.markAsDirty();
          }
          this.saveDisable = false;
          this.messageService.add({ severity: 'success', summary: 'Success', detail: "Image updated. Click 'Save Changes' to apply." });
        }
      },
      error: (error) => {
        console.error('Error uploading file to GCS: ', error);
      }
    });
  }

  currentTab: WritableSignal<OrganizationTabs> = signal<OrganizationTabs>("organization-settings");
  switchCurrentTab(tab: OrganizationTabs) {
    this.currentTab.set(tab);
  }

  getTimeFormatLabel() {
    return this.timeList.find((time) => time.value === this.companyData.time_format).name;
  }
}

